import { Navigate, Route, Routes, useParams } from "react-router-dom";

import { ChangeRequestsPage } from "../features/changeRequests/pages/ChangeRequestsPage";
import { Comments } from "../features/documentation/pages/documentation-home-page/comments/Comments";
import { DocumentationPage } from "../features/documentation/pages/documentation-home-page/DocumentationPage";
import { EditSpaceModule } from "./EditSpaceModule";
import { NotFoundPage } from "./system/NotFoundPage";
import { SpaceOverview } from "../features/spaces/pages/spaces-home-page/overview/SpaceOverview";
import { SpaceService } from '../features/spaces/services/SpaceService';
import { useEffect } from "react";
import { useServiceCallPro } from "../common/services/UseServiceCall";
import { useSetSelectedSpace } from '../lib/infrastructure/ui/UIServices';

const spaceSvc = new SpaceService();

/**
 * The routes of one space. The rail (Overview, Pages, Changes, Settings) and the space chip are the shell's
 * (`modules/shell`); this module only loads the space for the chip and switches the screen.
 */
export function SpacesModule() {
  const [selectedSpace, setSelectedSpace] = useSetSelectedSpace();
  const { spaceId } = useParams();
  const getByIdServiceCall = useServiceCallPro(spaceSvc.getById);

  useEffect(() => {
    if (spaceId && spaceId !== selectedSpace?.id) {
      getByIdServiceCall.invoke(spaceId)
        .then((res) => setSelectedSpace({ id: spaceId, name: res.title }))
        // a space that does not answer keeps no chip; its screens show their own not-found state
        .catch(() => setSelectedSpace(undefined));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [spaceId]);

  useEffect(() => () => setSelectedSpace(undefined), [setSelectedSpace]);

  return (
    <Routes>
      <Route index element={<Navigate to="pages" replace />} />
      <Route path="overview" element={<SpaceOverview />} />
      <Route path="pages" element={<DocumentationPage />} />
      <Route path="pages/:pageId" element={<DocumentationPage />} />
      <Route path="pages/:pageId/comments" element={<Comments />} />
      <Route path="edit/*" element={<EditSpaceModule />} />
      <Route path="change-requests" element={<ChangeRequestsPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
